import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProofSection } from './components/SocialProofSection';
import { DifferentiationSection } from './components/DifferentiationSection';
import { NfcTapAnimation } from './components/NfcTapAnimation';
import { ComparisonSection } from './components/ComparisonSection';
import { ShopSection } from './components/ShopSection';
import { UrgencySection } from './components/UrgencySection';
import { VideoDemoSection } from './components/VideoDemoSection';
import { FAQSection } from './components/FAQSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { BundleDealPopup } from './components/BundleDealPopup';
export function App() {
  useEffect(() => {
    document.title = 'QTap WC Smart T-Shirt';
    // Force scroll to top on load to prevent browser from jumping to hash links or restoring scroll position
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-brand-darkest font-body text-white overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <NfcTapAnimation data-id="element-7" />
        <DifferentiationSection data-id="element-8" />
        <ComparisonSection data-id="element-9" />
        <ShopSection data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <VideoDemoSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <SocialProofSection data-id="element-14" />
        <FinalCtaSection data-id="element-15" />
      </main>

      <Footer data-id="element-16" />

      <SocialProofPopup data-id="element-17" />
      <BundleDealPopup data-id="element-18" />
    </div>;
}